import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stocking-dash-board',
  templateUrl: './stocking-dash-board.component.html',
  styleUrls: ['./stocking-dash-board.component.scss']
})
export class StockingDashBoardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
